let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kVxjO")).then(() => parcelRequire('8jisX'));